import { AauthService } from './services/aauth.service';
import { AlertService } from './services/alert.service';
import { AppHttpService } from './services/app-http.service';
import { AppRoutingModule } from './app-routing.module';
import { AuthGuard } from './services/auth-guard.service';
import { AppSelect2Directive } from './Directives/app-select2.directive';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { CookieService } from 'ngx-cookie-service';
import { DbdataService } from './services/dbdata.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GoogleLoginProvider, FacebookLoginProvider } from 'angularx-social-login';
import { HttpClientModule } from '@angular/common/http';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { RecaptchaFormsModule, RecaptchaModule, RECAPTCHA_SETTINGS, RecaptchaSettings } from 'ng-recaptcha';
import { ToastrModule } from 'ngx-toastr';
import { TmNgOdometerModule } from 'tm-ng-odometer';

// Components
import { AppComponent } from './app.component';
import { ContentPageComponent } from './feature-modules/content-pages/content-page/content-page.component';
import { ContentSectionComponent } from './feature-modules/content-pages/content-section/content-section.component';
import { HomeComponent } from './feature-modules/home/home.component';
import { LoginComponent } from './components/shared-components/login/login.component';
import { MainLayoutComponent } from './components/layout-components/main-layout/main-layout.component';
import { MinimalLayoutComponent } from './components/layout-components/minimal-layout/minimal-layout.component';
import { NarrativeTextComponent } from './components/shared-components/narrative-text/narrative-text.component';
import { NavigateComponent } from './feature-modules/navigate/navigate.component';
import { PageNotFoundComponent } from './components/pages/page-not-found/page-not-found.component';
import { SearchComponent } from './components/shared-components/search/search.component';
import { UserCounterComponent } from './components/shared-components/user-counter/user-counter.component';

// Managers
import { LocalStoreManager } from './services/local-store-manager.service';

// Modules
import { ClaimModule } from './feature-modules/claim/claim.module';
import { RegisterModule } from './feature-modules/register/register.module';
import { SocialLoginModule, AuthServiceConfig } from 'angularx-social-login';

// Pipes
import { safeHtml } from './pipes/safe-html/safe-html.pipe';

// Services
import { ConfigurationService } from './services/configuration.service';
import { ManualClaimComponent } from './feature-modules/claim/manual-claim/manual-claim.component';

import {GoogleAnalyticsService} from './services/google-analytics.service';                                             // 09-16-2021 - dwn: added per: https://www.dottedsquirrel.com/google-analytics-angular/

//import { NgxHotjarModule } from 'ngx-hotjar';                                                                         // 08-22-2021 - dwn: added per: https://github.com/maxandriani/ngx-hotjar

const config = new AuthServiceConfig([
  {
    id: GoogleLoginProvider.PROVIDER_ID,
    provider: new GoogleLoginProvider(ConfigurationService.SETTING_GOOGLE_CLIENTID)
  },
  {
    id: FacebookLoginProvider.PROVIDER_ID,
    provider: new FacebookLoginProvider(ConfigurationService.SETTING_FACEBOOK_APPID)
  }
]);

export function provideConfig() {
  return config;
}

@NgModule({
  declarations: [
    AppSelect2Directive,
    AppComponent,
    HomeComponent,
    LoginComponent,
    NarrativeTextComponent,
    PageNotFoundComponent,
    safeHtml,
    SearchComponent,
    UserCounterComponent,
    NavigateComponent,
    ContentPageComponent,
    MainLayoutComponent,
    MinimalLayoutComponent,
    ContentSectionComponent,
    ManualClaimComponent
  ],
  imports: [
    AppRoutingModule,
    BrowserAnimationsModule,
    BrowserModule,
    ClaimModule,
    FormsModule,
    HttpClientModule,
    NgbModule,
    ReactiveFormsModule,
    RegisterModule,
    RecaptchaModule,
    RecaptchaFormsModule,
    SocialLoginModule.initialize(config),
    ToastrModule.forRoot(),
    TmNgOdometerModule
  ],
  providers: [
   { provide: AuthServiceConfig, useFactory: provideConfig },                                                           // login fb/google
    [GoogleAnalyticsService],
    LocalStoreManager,
    ConfigurationService,
    AlertService,
    DbdataService,
    AauthService,
    CookieService,
    AuthGuard,
    AppHttpService,
    {
      provide: RECAPTCHA_SETTINGS,
      useValue: { siteKey:  ConfigurationService.SETTING_CAPTCHA_SITEKEY } as RecaptchaSettings,
    },
    { provide: LocationStrategy, useClass: HashLocationStrategy },
  ],
  exports: [
    AppSelect2Directive,
    NgbModule
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
